import Block from '@/layouts/block'
import { Directions } from '@/lib/constants'
import ProgressIndicator from '@/components/progress'

export interface WithinPageNav {
  activeElementIndex: number
  handleChangeActiveElemIndex: (index: number) => void
  handleWithinPageNav: (d: Directions) => void
}

type WithinPageNavProps = Omit<WithinPageNav, 'handleWithinPageNav'> & {
  className?: string
  numOfItems: number
  prevBtn: React.ReactNode | null
  nextBtn: React.ReactNode | null
}

const WithinPageNavigation = ({
  className = '',
  numOfItems,
  activeElementIndex,
  handleChangeActiveElemIndex,
  prevBtn,
  nextBtn,
}: WithinPageNavProps) => {
  return (
    <Block
      className={`${className} w-full flex flex-col items-center justify-center `}
    >
      <ProgressIndicator
        numOfItems={numOfItems}
        activeIndex={activeElementIndex}
        onClick={handleChangeActiveElemIndex}
      />
      <Block className="flex flex-wrap gap-[10px] items-center w-full mt-12">
        {prevBtn && <div className="mx-auto">{prevBtn}</div>}
        {nextBtn && <div className="mx-auto">{nextBtn}</div>}
      </Block>
    </Block>
  )
}

export default WithinPageNavigation
